// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../node_modules/postcss-loader/dist/cjs.js!../../style/theme.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header_H7rf2 {
  display: flex;
}
.flexRight_EMWIN {
  margin-left: auto;
}
.left_uPtED {
  height: 100%;
}
.pagination_pTf9R { 
  border-top : 1px solid var( --lighter-grey );
  background: white;
  position:absolute;
  bottom : 0;
  margin : 0;
  height : 40px;
  width : 100%;
  display: flex;
  justify-content:center;
  align-items:center;

  .innerPagination_bFcJQ {
    margin : 0
  }
}
.header_H7rf2 {
  padding : 10px 26px 10px 20px;
  text-align:right;
  display:flex;
  flex-direction:row;
  justify-content:space-between;
  align-items:center;
  border-bottom:5px solid var( --background );/*var( --border-color );*/
}

.timerSplit_NrYTQ {
  height: 100%;
  padding-bottom : 40px;
}

.splitLeft_h446H {
  height: 100%;
  border-right:1px solid var( --lighter-grey );
}
.splitRight_bKiHc {
  width: 450px;
  height: 100%;
  background : var( --background );
}
.stopTimer_e9gUT i {
  color: var( --red );
}
.deleteTimer_Pep2Y i {
  color: var( --grey )
}

.noItems_RUMPv {
  text-align: left;
  padding: 20px 20px;
}`, "",{"version":3,"sources":["webpack://./src/screens/timer/style.css"],"names":[],"mappings":"AAEA;EACE,aAAa;AACf;AACA;EACE,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;AACA;EACE,4CAA4C;EAC5C,iBAAiB;EACjB,iBAAiB;EACjB,UAAU;EACV,UAAU;EACV,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,kBAAkB;;EAElB;IACE;EACF;AACF;AACA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;EAClB,2CAA2C,CAAC,yBAAyB;AACvE;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,4CAA4C;AAC9C;AACA;EACE,YAAY;EACZ,YAAY;EACZ,gCAAgC;AAClC;AACA;EACE,mBAAmB;AACrB;AACA;EACE;AACF;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB","sourcesContent":["@import \"../../style/theme.css\";\n\n.header {\n  display: flex;\n}\n.flexRight {\n  margin-left: auto;\n}\n.left {\n  height: 100%;\n}\n.pagination { \n  border-top : 1px solid var( --lighter-grey );\n  background: white;\n  position:absolute;\n  bottom : 0;\n  margin : 0;\n  height : 40px;\n  width : 100%;\n  display: flex;\n  justify-content:center;\n  align-items:center;\n\n  .innerPagination {\n    margin : 0\n  }\n}\n.header {\n  padding : 10px 26px 10px 20px;\n  text-align:right;\n  display:flex;\n  flex-direction:row;\n  justify-content:space-between;\n  align-items:center;\n  border-bottom:5px solid var( --background );/*var( --border-color );*/\n}\n\n.timerSplit {\n  height: 100%;\n  padding-bottom : 40px;\n}\n\n.splitLeft {\n  height: 100%;\n  border-right:1px solid var( --lighter-grey );\n}\n.splitRight {\n  width: 450px;\n  height: 100%;\n  background : var( --background );\n}\n.stopTimer i {\n  color: var( --red );\n}\n.deleteTimer i {\n  color: var( --grey )\n}\n\n.noItems {\n  text-align: left;\n  padding: 20px 20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `header_H7rf2`,
	"flexRight": `flexRight_EMWIN`,
	"left": `left_uPtED`,
	"pagination": `pagination_pTf9R`,
	"innerPagination": `innerPagination_bFcJQ`,
	"timerSplit": `timerSplit_NrYTQ`,
	"splitLeft": `splitLeft_h446H`,
	"splitRight": `splitRight_bKiHc`,
	"stopTimer": `stopTimer_e9gUT`,
	"deleteTimer": `deleteTimer_Pep2Y`,
	"noItems": `noItems_RUMPv`
};
export default ___CSS_LOADER_EXPORT___;
